/* eslint-disable @typescript-eslint/no-explicit-any */
import { Expose, Transform } from 'class-transformer';
import { ValuePairDto } from './base/value-pair.dto';

export class EmptyBedReasonsDto {
  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'openBedLessTwoWeekReferral'))
  openBedLessTwoWeekReferral!: ValuePairDto<number | null>;

  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'openBedTwoWeekNoReferral'))
  openBedTwoWeekNoReferral!: ValuePairDto<number | null>;

  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'onHoldPendingOrMatched'))
  onHoldPendingOrMatched!: ValuePairDto<number | null>;

  // @Expose()
  // @Transform(({ obj }) => mapCurrentPrevious(obj, 'onHoldMismatches'))
  // onHoldMismatches!: ValuePairDto<number | null>;

  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'bedMismatchPhysical'))
  bedMismatchPhysical!: ValuePairDto<number | null>;

  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'bedMismatchSmoking'))
  bedMismatchSmoking!: ValuePairDto<number | null>;

  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'bedMismatchPeerGender'))
  bedMismatchPeerGender!: ValuePairDto<number | null>;

  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'bedMismatchEquipment'))
  bedMismatchEquipment!: ValuePairDto<number | null>;

  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'bedMismatchCognitive'))
  bedMismatchCognitive!: ValuePairDto<number | null>;

  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'bedMismatchClientRefusal'))
  bedMismatchClientRefusal!: ValuePairDto<number | null>;

  // @Expose()
  // @Transform(({ obj }) => mapCurrentPrevious(obj, 'tempCloseEmergencyResponse'))
  // tempCloseEmergencyResponse!: ValuePairDto<number | null>;

  // @Expose()
  // @Transform(({ obj }) => mapCurrentPrevious(obj, 'tempCloseInfectionControl'))
  // tempCloseInfectionControl!: ValuePairDto<number | null>;

  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'tempCloseMaintenance'))
  tempCloseMaintenance!: ValuePairDto<number | null>;

  // @Expose()
  // @Transform(({ obj }) => mapCurrentPrevious(obj, 'tempCloseStaffingIssue'))
  // tempCloseStaffingIssue!: ValuePairDto<number | null>;

  @Expose()
  @Transform(({ obj }) => mapCurrentPrevious(obj, 'tempCloseOther'))
  tempCloseOther!: ValuePairDto<number | null>;
}

function mapCurrentPrevious<T extends Record<string, any>, K extends keyof T>(
  src: T,
  key: K
): ValuePairDto<T[K]> {
  const prevKey = `${String(key)}Previous` as keyof T;
  return { current: src[key], previous: src[prevKey] as T[K] };
}
